module.exports = __webpack_public_path__ + "media/Video 84.42e66040.mp4";